(function() {
  
  angular
    .module('app.plugins', ['app.inflector']);
  
})();